// extracted by mini-css-extract-plugin
export default {"banner":"XNM_BGYy","leftSide":"p4Wzk0UG","name":"emmDPFMO","description":"ADl7UJJO","title":"zHpH1zeo","buttonWrapper":"WGzs42xg","rightSide":"lTFakVYX","mobImgBox":"KxHCmTny","imgBox":"byDdGCYr","img":"VvGJJ7i6","button":"wIfTWO8P","linkButton":"lYUd3QNr","denialButton":"TwXs7sd1","disabled":"onq87LUE","hasBackgroundImage":"Sn31EB44","hidden":"XQlgHUjt"};
    if(module.hot) {
      // 1717522983526
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  